// Copyright © 2021 Move Closer
export const UserComServiceType = Symbol.for('IUserComService');
